<template>
  <div class="my-bargain">
    <EmptyData emptyName="noBargain" v-if="noData" />
    <div v-else>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div
          class="card"
          v-for="item in bargainList"
          :key="item.id"
          @click="jumpBargainPage(item.id,item.skuId)"
        >
          <BargainCard :cardDetail="item" :nowTime="nowTime" />
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import BargainCard from '@/pages/personalCenter/myActivity/myBargain/BargainCard.vue';
import { reqBargainList } from '@/api/personal';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { setBaseUrl } from '@/utils/tools';



export default {
  components: {
    BargainCard,
    EmptyData,
  },
  data() {
    return {
      refreshing: false,
      bargainList: [],
      nowTime: new Date().getTime(),
      noData: false,
    };
  },
  mounted() {
    this.getBargainList();
  },
  methods: {
    async getBargainList() {
      const res = await reqBargainList();
      if (res.code === 0) {
        this.nowTime = res?.currentTime ? res.currentTime : new Date().getTime();
        this.bargainList = res.data || [];
        this.noData = this.bargainList.length === 0;
      }
    },
    async onRefresh() {
      await this.getBargainList();
      this.refreshing = false;
    },
    jumpBargainPage(activityId,skuId) {
      const pagePath = `/ark/personalCenter/bargainDetail?activityId=${activityId}&skuId=${skuId}`;
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}${pagePath}` },
          false,
        );
        return;
      }
      this.$router.push({
        path: '/personalCenter/bargainDetail',
        query: { activityId,skuId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.my-bargain {
  width: 100%;
  min-height: calc(100vh - 172px);
  padding-top: 20px;
  padding-bottom: 100px;

  .card {
    margin-bottom: 22px;
  }
}
</style>
